// FL-11 — wait-state polish. Inline spinner + plain-language "this can
// take up to a minute" copy. Surfaces while the AI advisory and the
// signing flows run, so the recipient knows a slow server call is
// expected rather than broken.

interface WaitStateProps {
  /** Headline above the wait copy. Defaults to a generic "Working on it". */
  label?: string;
  /** Optional override for the wait copy. */
  message?: string;
}

const DEFAULT_MESSAGE = "This can take up to a minute — please don't close this tab.";

export function WaitState({ label = "Working on it…", message = DEFAULT_MESSAGE }: WaitStateProps) {
  return (
    <div
      className="flex items-start gap-space-3 p-space-3 border border-border-light rounded-md bg-white-pure"
      role="status"
      aria-live="polite"
      data-testid="wait-state"
    >
      <Spinner />
      <div className="flex flex-col">
        <span className="text-small font-medium text-onyx">{label}</span>
        <span className="text-caption text-gray-mid mt-space-1">{message}</span>
      </div>
    </div>
  );
}

function Spinner() {
  return (
    <span
      aria-hidden="true"
      className="inline-block w-4 h-4 rounded-full border-2 border-gold border-t-transparent animate-spin shrink-0 mt-[2px]"
    />
  );
}
